import { enderecoStep, DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL } from '../../shared/enderecoSections';
import { termosStep } from '../../shared/termosSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';

const pedidoRecadastramentoConfig = {
  id: 'pedido_recadastramento',
  nome: 'Pedido de Recadastramento',
  categoria: 'pedidos',
  descricao: 'Solicitação de recadastramento na OAB/MS',
  icon: 'FaFileAlt',

  documentConfig: {
    required: [
      { 
        id: 'requerimento', tipoDocumentoProcesso: 433, 
        name: 'Requerimento', 
        description: 'Requerimento de Recadastramento e assinado digitalmente', 
        required: true 
      },
      { id: 'RG', tipoDocumentoProcesso: 533, 
        name: 'RG Atualizado', 
        description: 'RG Atualizado (Com Expedição Recente)', 
        required: true 
      },
      { id: 'tituloEleitor', tipoDocumentoProcesso: 511, 
        name: 'Título de Eleitor', 
        description: 'Título de Eleitor', 
        required: true 
      },

    ],
  },

  paymentConfig: {
    amount: 164.00
  },

  protocoloConfig: {
    modeloRequerimento: '204',
    tiposAssunto: '823',
    tipoPedido: '252'
  },

  dadosRequerimentoConfig: mergeDadosRequerimentoConfig(
    {
      campos: [
        { field: 'nomeCompleto', campoNome: 'Nome' },
        { field: 'cpf', campoNome: 'CPFCNPJ' }
      ]
    },
    DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL
  ),

  tituloConfig: {
    tipoLancamentoId: 65,
    enderecoOrigem: 'residencial'
  },

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { 
              type: 'text', 
              name: 'nomeCompleto', 
              label: 'Nome completo', 
              required: true, 
              placeholder: 'Digite seu nome completo' 
            },
            { 
              type: 'cpf', 
              name: 'cpf', 
              label: 'CPF', 
              required: true 
            }
          ]
        }
      ]
    },
    enderecoStep({ autoCep: true }),
    termosStep()
  ]
};

export default pedidoRecadastramentoConfig;